import { render, staticRenderFns } from "./FooterBasis.vue?vue&type=template&id=157e39a9&scoped=true&"
import script from "./FooterBasis.vue?vue&type=script&lang=js&"
export * from "./FooterBasis.vue?vue&type=script&lang=js&"
import style0 from "./FooterBasis.vue?vue&type=style&index=0&lang=less&"
import style1 from "./FooterBasis.vue?vue&type=style&index=1&id=157e39a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e39a9",
  null
  
)

export default component.exports